<template>
  <li :class="{ current: active }">
    <router-link :to="{ name: 'UserEvents' }"
      ><i class="fa fa-list-alt"></i> Events</router-link
    >
    <div class="grid-container4">
      <ul>
        <li>
          <router-link :to="{ name: 'BookingEvents' }"
            ><i class="fa fa-calendar-check-o"></i>All Bookings</router-link
          >
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
